var _circle, _circle2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 243,
    height: 243,
    viewBox: "0 0 243 243",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 121.5,
    cy: 121.5,
    r: 121.5,
    fill: "#58B0F4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_278_2614",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 243,
    height: 243
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 121.5,
    cy: 121.5,
    r: 121.5,
    fill: "#58B0F4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_278_2614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.14 265H-51.222C-57.6773 265 -61.9807 259.58 -60.8071 252.855L-41.9304 141.145C-40.7567 134.42 -34.5949 129 -28.1397 129H174.222C180.677 129 184.981 134.42 183.807 141.145L164.93 252.855C163.757 259.58 157.595 265 151.14 265Z",
    fill: "#BDCCD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1013 175.3L9.50127 218.4H-59.1987L-51.9987 175.3H17.1013Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8011 175.3L89.2011 218.4H13.6011L21.2011 175.3H96.8011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.401 218.4H93.4011L101.001 175.3H169.601L170.301 171.1H101.701L109.101 129H104.901L97.5011 171.1H21.9011L29.3011 129H25.1011L17.8011 171.1H-51.2989L-51.9989 175.3H17.0011L9.40108 218.4H-59.1989L-59.8989 222.6H8.70107L1.30107 264.7H5.50107L12.9011 222.6H88.5011L81.1011 264.7H85.3011L92.7011 222.6H161.801L162.401 218.4ZM13.6011 218.4L21.2011 175.3H96.8011L89.2011 218.4H13.6011Z",
    fill: "#BDCCD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.701 252.5C155.601 259.2 149.501 264.6 143.201 264.6H85.2012L92.6012 222.5H161.701L156.701 252.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.401 218.4H93.4014L101.001 175.3H169.601L162.401 218.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.301 171.1H101.701L109.101 129H165.801C172.101 129 176.401 134.4 175.301 141.1L170.301 171.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.001 129L97.5014 171.1H21.9014L29.4014 129H105.001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2012 129L17.8012 171.1H-51.2988L-46.2988 141.1C-45.1988 134.4 -39.0988 129 -32.7988 129H25.2012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.501 222.5L81.101 264.6H5.50098L12.901 222.5H88.501Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70116 222.5L1.30117 264.6H-55.3988C-61.6988 264.6 -65.9988 259.2 -64.7988 252.5L-59.7988 222.5H8.70116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.446 105.57C151.768 112.466 146.157 119.361 140.673 146.431C140.418 147.453 138.888 147.453 138.633 146.431C133.15 119.361 127.539 112.466 105.861 105.57C104.713 105.187 104.713 103.527 105.861 103.272C127.539 96.3768 133.15 89.4816 138.633 62.4113C138.888 61.3898 140.418 61.3898 140.673 62.4113C146.157 89.4816 151.768 96.3768 173.446 103.272C174.466 103.527 174.466 105.187 173.446 105.57Z",
    fill: "#1F243B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarIcon);
export default __webpack_public_path__ + "static/media/solar-icon.6cec924ebcded2c669beefb79597ff0b.svg";
export { ForwardRef as ReactComponent };